import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CodeLoginForm from './CodeLoginForm';
import CodeRegisterForm from './CodeRegisterForm';

function AuthForm(props) {
  return (
    <div className="login__form">
      <div className="login__logo">&nbsp;</div>
      {
        props.loginCodeState === '2FA_REG' ?
          <CodeRegisterForm
            dispatch={props.dispatch}
            resetLogin={props.resetLogin}
          /> :
          <CodeLoginForm
            onSubmit={props.onSubmit}
            isLoading={props.isLoading}
          />
      }
    </div>
  );
}

AuthForm.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  loginCodeState: PropTypes.string,
  dispatch: PropTypes.func,
  resetLogin: PropTypes.func,
};

export default injectIntl(AuthForm);
